module.exports = __webpack_public_path__ + "img/8market3-a.17030542.jpg";